import { Link } from 'react-router-dom';

const QuickLinksSection = () => {
  const links = [
    {
      number: '01',
      title: 'Our Works',
      path: '/our-works',
      image: 'https://public.readdy.ai/ai/img_res/97554986af32220ca6dd20bd92ed98fa.jpg',
    },
    {
      number: '02',
      title: 'Bathroom Offers',
      path: '/bathroom-offers',
      image: 'https://readdy.ai/api/search-image?query=modern%20bathroom%20suite%20display%20contemporary%20toilet%20washbasin%20and%20shower%20elegant%20design%20showroom%20quality%20clean%20minimalist%20style%20light%20neutral%20background%20cream%20and%20white%20tones&width=600&height=800&seq=link-002&orientation=portrait',
    },
    {
      number: '03',
      title: 'Complex Heating',
      path: '/complex-heating',
      image: 'https://readdy.ai/api/search-image?query=heating%20system%20installation%20in%20progress%20professional%20technician%20working%20on%20boiler%20and%20pipes%20modern%20equipment%20clean%20organized%20workspace%20light%20neutral%20background%20technical%20setup&width=600&height=800&seq=link-003&orientation=portrait',
    },
    {
      number: '04',
      title: 'Special Offers',
      path: '/special-offers',
      image: 'https://readdy.ai/api/search-image?query=promotional%20discount%20badge%20design%20special%20offer%20banner%20with%20percentage%20symbol%20vibrant%20orange%20and%20white%20colors%20clean%20modern%20graphic%20design%20light%20background&width=600&height=800&seq=link-004&orientation=portrait',
    },
    {
      number: '05',
      title: 'Testimonials',
      path: '/testimonials',
      image: 'https://readdy.ai/api/search-image?query=happy%20satisfied%20customer%20in%20newly%20renovated%20bathroom%20smiling%20person%20with%20modern%20bathroom%20background%20positive%20experience%20professional%20service%20light%20bright%20setting%20natural%20tones&width=600&height=800&seq=link-005&orientation=portrait',
    },
  ];

  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-primary mb-4">
            Explore Our Services
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Discover our comprehensive range of plumbing and heating solutions tailored to your needs.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
          {links.map((link, index) => (
            <Link
              key={index}
              to={link.path}
              className="group relative overflow-hidden rounded-xl aspect-[3/4] cursor-pointer"
            >
              <div className="w-full h-full">
                <img
                  src={link.image}
                  alt={link.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent group-hover:from-black/90 transition-all duration-300"></div>
              <div className="absolute top-6 left-6">
                <span className="text-white/60 text-4xl font-bold">{link.number}</span>
              </div>
              <div className="absolute bottom-6 left-6 right-6">
                <h3 className="text-white text-2xl font-bold mb-2">{link.title}</h3>
              </div>
              <div className="absolute bottom-6 right-6">
                <div className="w-10 h-10 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full group-hover:bg-accent transition-colors">
                  <i className="ri-arrow-right-line text-white text-lg"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default QuickLinksSection;